export default __webpack_public_path__ + "static/media/logo-reactor.52ff81e1.png";